import { BaseElementController } from '../../modules/BaseElementController';
import * as s from './SignIn.scss';
import { BiLogger, fireBiEventsOnHover } from '../../modules/BiLogger';

interface SignInControllerParams {
  biLogger: BiLogger;
}

export class SignInController extends BaseElementController {
  private readonly biLogger: BiLogger;
  private readonly elements: {
    buttons: HTMLAnchorElement[];
    wrapper: HTMLDivElement;
  };

  constructor({ biLogger }: SignInControllerParams) {
    super();
    this.biLogger = biLogger;
    this.elements = {
      buttons: this.$$<HTMLAnchorElement>(`.${s.signIn}`),
      wrapper: this.$<HTMLDivElement>(`.${s.signInContainer}`)!,
    };
  }
  init() {
    this.elements.buttons.forEach((linkEl) => {
      const biName = linkEl.getAttribute('data-bi-name') || undefined;
      const href = linkEl.href;
      linkEl.addEventListener('click', (e) => {
        e.preventDefault();
        const referencedWindow = linkEl.target === '_blank' ? window.open() : window;
        this.biLogger.clickButton({ button_name: biName, to: href }).then(() => {
          referencedWindow && referencedWindow.location.assign(href);
        });
      });

      this.addOriginParamToLink(linkEl);
      fireBiEventsOnHover({ element: linkEl, href, name: biName, logger: this.biLogger });
    });
  }

  private addOriginParamToLink(link: HTMLAnchorElement) {
    link.href = link.href.concat(`&originUrl=${encodeURIComponent(location.href)}`);
  }

  removeElement() {
    // @ts-ignore
    this.elements.wrapper.remove();
  }

  addShadow() {
    this.elements.wrapper.classList.add(s.hasShadow);
  }

  removeShadow() {
    this.elements.wrapper.classList.remove(s.hasShadow);
  }
}
